export enum EWeightUnit {
  POUNDS = 'pounds',
  OUNCES = 'ounces',
}

export enum EDimensionUnit {
  INCHES = 'inches',
  CENTIMETERS = 'centimeters',
}
